/**
 * Locale (en-US) — copy specific to the modern Requests list. Only new
 * keys are added; we reuse existing translations from
 * `applications/locales/en-US.js` for origin, statuses, etc.
 */
export default {
  'applicationsModern.title': 'Requests',
  'applicationsModern.summary': 'Browse requests, filter by status and open their detail.',
  'applicationsModern.refresh': 'Refresh',

  'applicationsModern.section.eyebrow': 'Results',
  'applicationsModern.section.title': 'Requests found',
  'applicationsModern.section.kicker': 'Showing {shown} of {total} requests',
  'applicationsModern.section.kickerEmpty': 'No matches for the active filters',

  'applicationsModern.empty.title': 'No requests found',
  'applicationsModern.empty.description': 'Adjust your filters or date range to see more results.',
  'applicationsModern.empty.descriptionFor':
    'No requests under "{origin}" match the current filters. Try changing the date, status, or origin.',
  'applicationsModern.filters.toggle': 'Filters',
  'applicationsModern.toolbar.order.desc': 'Newest',
  'applicationsModern.toolbar.order.asc': 'Oldest',
  'applicationsModern.filters.clearAll': 'Clear all',
  'applicationsModern.filters.from': 'From',
  'applicationsModern.filters.to': 'To',
  'applicationsModern.filters.remove': 'Remove',
  // Global aliases (only if not yet in common.js)
  'global.text.from': 'From',
  'global.text.to': 'To',
  'global.button.remove': 'Remove',
};
